module.exports = __webpack_public_path__ + "img/technoker_auth.625a4d99.png";